console.log("Controller Index: index.js loaded");

import { application } from "./application"

import InstanceDetailsController from "./instance_details_controller.js"
application.register("instance-details", InstanceDetailsController)

import ModalController from "./modal_controller.js"
application.register("modal", ModalController)

import SearchFormController from "./search_form_controller.js"
application.register("search-form", SearchFormController)

import KeyboardShortcutController from "./keyboard_shortcut_controller.js"
application.register("keyboard-shortcut", KeyboardShortcutController)

import WebPushSubscriptionController from "./web_push_subscription_controller.js"
application.register("web-push-subscription", WebPushSubscriptionController)
